const DEFAULT_SETTINGS = {
  /*
  fieldId: { // Same ID as supplied to <Input />
    value: '',
    defaultValue: '', // Update StepReview.jsx & relevant step(s) if you need to output
  }
  */

  /* Default Advanced Settings */
  batchSize: {
    defaultValue: '10000',
  },
  throttleEnabled: {
    value: false, // We want to default to true on render, but never compare the default
  },
  subscribeToAllLog: {
    value: true, // We want to default to true on render, but never compare the default
  },

  awsSecurityLakeName: {
    value: '',
  },
  storeFullMessage: {
    value: false, // We want to default to true on render, but never compare the default
  },

  awsSecurityLakeThrottleEnabled: {
    value: undefined,
  },
  awsSecurityLakeStoreFullMessage: {
    value: true,
  },

  pollingInterval: {
    value: 5,
  },

};

export default DEFAULT_SETTINGS;
